<template>
  <list :state="-1" />
</template>
<script>
export default {
  components: { list: () => import("./list.vue") }
}
</script>